module.exports = __webpack_public_path__ + "static/media/sentiment.c501f6e6.png";